<template>
  <!-- Activity / Activity Classification -->
  <!-- Change State historyType => 4 -->
  <!-- Attachment Image -->
  <!-- Attachment File -->
  <!-- Created historyType => 1-->
  <!-- Updated historyType => 2-->
  <!-- Intention => historyType => 3 -->
  <div class="fts-history-content" :class="{ 'child': child, 'content-lv2': typeComment }">
    <div class="history-content-wrapper">
      <div class="history-content-header">
        <fts-profile :userName="data.by" class="test history-content-header-l">
          <div
            slot="profileName"
            slot-scope="{ userProfileName }"
            class="history-content-header-wrapper"
          >
            <span class="history-content-username">{{userProfileName}}</span>
            <!-- comment reply -->
            <template v-if="typeCommentReply">
              <span class="fts-inline-spacer-1"></span>
              <span class="history-content-date">{{createdDate}}</span>
            </template>
            <!-- activity -->
            <template v-if="activity">
              completed <span class="history-content-title">{{activity}}</span>
            </template>
            <!-- standard activity -->
            <span v-else-if="standardActivityType === 1">created this</span>
            <span v-else-if="standardActivityType === 2">updated this</span>
            <span v-else-if="standardActivityType === 4">changed state</span>
            <span v-else-if="standardActivityType === 7">has done assigned</span>
            <span v-else-if="standardActivityType === 8">imported this</span>
            <span v-else-if="standardActivityType === 9">merged this</span>
            <span v-else-if="typeComment">commented this</span>
          </div>
        </fts-profile>
        <!-- state -->
        <fts-state
          :state="data.state"
          class="history-content-state"
          v-if="data.state && data.state.name"
        />
      </div>
      <!-- attachments -->
      <fts-file 
        :prefixURL="`${vectorId}-comment/`" 
        :data="data.attachments" 
        :downloadable="true" 
        :audit="{
          userName: data.by,
          date: data.on
        }"
        :description="historyContent"
        class="history-content-atch"
        :class="[
          {'history-content-atch-bg': child || typeComment}, 
          {'atch-bg': !historyContent}
        ]" />
      <!-- comment -->
      <template v-if="historyContent">
        <div class="history-content-comment-lv2 fts-contenteditable-display" v-html="data.content" v-if="typeComment" />
        <div class="history-content-comment fts-contenteditable-display" v-html="data.content" v-else />
      </template>
      <!-- footer -->
      <div class="history-content-footer">
        <!-- date -->
        <div class="history-content-footer-wrapper" v-if="!child">{{createdDate}}</div>
        <!-- channel -->
        <div class="history-content-footer-wrapper history-content-action" v-if="channel">
          via
          <a
            :href="channel.url"
            target="_blank"
            class="fts-link-primary"
            v-if="channel.url"
          >
            {{channel.name}}
          </a>
          <span class="fts-text-primary" v-else>
            {{channel.name}}
          </span>
        </div>
        <!-- comment -->
        <div
          class="history-content-footer-wrapper history-content-action fts-link-default"
          @click="toggleComment"
          v-if="commentSection"
        >
          {{child ? 'reply' : 'comment'}}
        </div>
        <!-- change log -->
        <fts-tippy
          :options="{
            maxWidth: 400,
            placement: 'left-start',
            interactive: true,
            delay: [500 , 0],
            theme: 'light-border'
          }" 
          v-if="data.changes && data.changes.length > 0"
        >
          <div slot="trigger" class="history-content-footer-wrapper history-content-action">
            changes
          </div>
          <div slot="content" class="history-change-log">
            <div class="change-log-header">
              <div class="change-log-header-title">Changes</div> 
              <div class="change-log-header-date">{{createdDate}}</div>
            </div>
            <div class="change-log-content fts-scrollbar">
              <div class="change-log-item" v-for="x in data.changes" :key="x.id">
                <span>updated</span>
                <span class="fts-font-bold">{{x.DisplayName}}</span>
                <!-- Origin -->
                <template v-if="x.Original">
                  <span>from</span>
                  <span class="fts-font-bold">
                    <template v-if="x.Type === 6">{{moment(x.Original).format('lll')}}</template>
                    <template v-else>{{x.Original}}</template>
                  </span>
                </template>
                <!-- Current -->
                <template v-if="x.Current">
                  <span>to</span>
                  <span class="fts-font-bold">
                    <template v-if="x.Type === 6">{{moment(x.Current).format('lll')}}</template>
                    <template v-else>{{x.Current}}</template>
                  </span>
                </template>
              </div>
            </div>
          </div>
        </fts-tippy>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { htmlValidator } from "../../commons/validator";

import FTSProfile from "../FTSProfile";
import FTSState from "../FTSState";
import FTSFile from "../file/FTSFile";
import FTSTippy from "../FTSTippy"
import commons from '../../commons/commons';

export default {
  props: {
    data: Object,
    child: Boolean,
    locusId: Number,
    vectorId: [String, Number],
    commentSection: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    "fts-profile": FTSProfile,
    "fts-state": FTSState,
    "fts-file": FTSFile,
    "fts-tippy": FTSTippy
  },
  data: () => ({
    commentVisibility: false,
    changeExtension: [
      { displayName: 'DOB', current: '2020-06-15T17:29:00+08:00', original: '2020-06-15T17:29:00+08:00', infoType: 6 },
      { displayName: 'Date Time', current: '2020-06-15T17:29:00+08:00', original: '2020-06-15T17:29:00+08:00', infoType: 6 },
      { displayName: 'Time', current: '2020-06-15T17:29:00+08:00', original: '2020-06-15T17:29:00+08:00', infoType: 6 },
      { displayName: 'First Name', current: 'Jia Xiang', original: 'Chun Keat' },
      { displayName: 'Last Name', current: 'Tan', original: 'Wong' },
      { displayName: 'Age', current: '24', original: '25' },
      { displayName: 'Date Time Table' },
      { displayName: 'Sneakers' },
      { displayName: 'Employees' },
      { displayName: 'Number', current: 2500, original: 25000 },
      { displayName: 'Attachments (Image)' }
    ]
  }),
  methods: {
    moment,
    toggleComment() {
      this.commentVisibility = !this.commentVisibility;
      this.$emit("comment");
    },
  },
  computed: {
    standardActivityType() {
      return this.data.type ? parseInt(this.data.type) : 0;
    },
    activity() {
      return this.data.activity;
    },
    typeActivity() {
      return this.activity || this.standardActivityType ? true : false;
    },
    typeComment() {
      return !this.typeActivity && !this.child
    },
    typeCommentReply() {
      return !this.typeActivity && this.child
    },
    file() {
      if (
        this.data.attachment &&
        this.data.attachment.type === "file" &&
        this.data.attachment.path
      ) {
        return this.data.attachment;
      }
    },
    createdDate() {
      return this.data.on
        ? this.moment(this.data.on).format("ddd, MMM D, YY h:mm a")
        : "";
    },
    historyContent() {
      if (htmlValidator(this.data.content))
        return this.data.content 
    },
    channel() {
      if (this.data && this.data.channel)
        switch(this.data.channel) {
          case 'ios':
            return {
              name: 'iOS App',
              url: commons.iOSAppStoreURL,
            };
          case 'android':
            return {
              name: 'Android App',
              url: commons.androindPlayStoreURL,
            };
          case 'zapier':
            return {
              name: 'Zapier',
            };
          case 'integromat':
            return {
              name: 'Integromat',
            };
        }
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

$content-ml: calc(20px + 0.275rem);

.fts-history-content {
  margin-right: 0.75rem;
  margin-bottom: calc(1rem - 0.375rem);
  padding: 0.375rem;
  font-size: 0.75rem;
  color: var(--fts-gray-5);
  &:not(.child) {
    margin-left: calc(0.75rem - 0.375rem);
    .history-content-comment {
      font-size: 1rem;
    }
  }
  &.child {
    margin-left: calc(20px + 1.025rem);
    background: var(--fts-gray-2);
    border-radius: .25rem;

  }
  &.content-lv2 {
    .history-content-atch {
      padding-left: .35rem;
      padding-right: .35rem;
      &.history-content-atch-bg {
        margin-right: -0.375rem;
      }
      .file-wrapper {
        max-width: calc(50% - 0.135rem);
      }
    }
  }
  .history-content-wrapper {
    flex: 1;
    .history-content-header {
      display: flex;
      align-items: flex-start;
      margin-bottom: 0.135rem;
      .history-content-header-l {
        flex: 1 1 70%;
        min-width: 70%;
        min-height: 24px;
        align-items: flex-start;
        line-height: 1.25;
        .history-content-header-wrapper {
          padding-top: 3px;
          white-space: normal;
        }
        .history-content-username {
          color: $primaryColor;
        }
        .history-content-title {
          font-weight: bold;
        }
        .history-content-date {
          font-size: .675rem;
        }
      }
      .history-content-state {
        margin-left: 0.75rem;
        > div {
          font-size: 0.675rem;
        }
      }
    }
    .history-content-atch {
      &.history-content-atch-bg {
        background: var(--fts-gray-2);
        border-top-left-radius: .25rem;
        border-top-right-radius: .25rem;
        &.atch-bg {
          margin-bottom: .375rem;
          border-bottom-left-radius: .25rem;
          border-bottom-right-radius: .25rem;
        }
      }
      margin-left: $content-ml;   
      padding-top: .35rem;
      padding-bottom: .35rem;
    }
    .history-content-comment {
      margin-left: $content-ml;
      padding: .575rem 0;
      overflow-wrap: break-word;
      white-space: pre-wrap;
    }
    .history-content-comment-lv2 {
      margin-left: $content-ml;
      margin-right: -0.375rem;
      margin-bottom: .375rem;
      padding: .575rem;
      background: var(--fts-gray-2);
      border-radius: .25rem;
      overflow-wrap: break-word;
      white-space: pre-wrap;
    }

    .history-content-atch + .history-content-comment,
    .history-content-atch + .history-content-comment-lv2  {
      padding-top: calc(0.575rem - 0.35rem);
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    .history-content-footer {
      display: flex;
      align-items: center;
      margin-left: $content-ml;
      .history-content-footer-wrapper {
        &:not(:last-child) {
          margin-right: .75rem;
        }
        font-size: 0.675rem;
      }
    }
  }
}
// Change Log
.history-change-log {
  margin: -0.375rem -0.75rem;
  text-align: left;
  .change-log-header {
    display: flex;
    align-items: baseline;
    padding: .75rem;
    background: var(--fts-gray-2);
    .change-log-header-title {
      font-size: 1rem;
      font-weight: 700;
    }
    .change-log-header-date {
      margin-left: .75rem;
      font-size: .75rem;
    }
  }
  .change-log-content {
    max-height: 400px;
    overflow: auto;
    white-space: normal;
    word-break: break-all;
    .change-log-item {
      padding: .375rem .75rem;
    }
  }
}
</style>